const CONFIG = {
	//开发环境配置
	development: {
		baseUrl: 'http://landtrade-api.wpgcms.com/api', // 站点域名
		uploadUrl: 'http://landtrade-api.wpgcms.com/api/upload/file', // 图片统一上传地址
		sourceUrl: 'http://landtrade-api.wpgcms.com/api/static', // 资源路劲
		domainUrl: 'http://landtrade-api.wpgcms.com', //域名 
	},

	//生产环境配置
	production: {
		baseUrl: '/api', // 站点域名
		uploadUrl: '/api/upload/file', // 图片统一上传地址
		sourceUrl: '/api/static', // 资源路劲
		domainUrl: '', //域名 
	}

}
export default CONFIG[process.env.NODE_ENV]; // 根据运行环境自动切换配置